<template>
  <div class="carrier">
    <div class="search-add">
      <div>
        <el-input v-model="name" @keyup.enter.native="search" class="white" placeholder="请输入名称"></el-input>
        <el-button class="btn-blue" @click="search">搜索</el-button>
      </div>
      <div>
        <el-button class="btn-white" @click="openDialog">物流匹配</el-button>
        <el-button class="btn-blue" @click="openExpressDialog">+新增物流类型</el-button>
      </div>
    </div>
    <div class="table">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="name" label="WMS物流名称"></el-table-column>
        <el-table-column prop="typeName" label="物流类型"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" class="btn-text" @click="remove(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog title="新增承运商" top="35vh" :visible.sync="carrierDialog" width="380px">
      <div class="border"></div>
      <el-form ref="carrierForm" :rules="carrierFormRules" :model="carrierForm" label-width="80px">
        <el-form-item label="名称：" prop="name">
          <el-input v-model="carrierForm.name" class="white" placeholder="请输入名称"></el-input>
        </el-form-item>
        <el-form-item label="类型：" prop="type">
          <el-select v-model="carrierForm.type" class="white" placeholder="请选择类型">
            <el-option v-for="item in typeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button class="btn-white" @click="closeDialog">取消</el-button>
          <el-button class="btn-blue" @click="addcarrier('carrierForm')">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog title="新增快递" top="35vh" :visible.sync="expressDialog" width="380px">
      <div class="border"></div>
      <el-form ref="expressForm" :rules="expressFormRules" :model="expressForm" label-width="80px">
        <el-form-item label="名称：" prop="name">
          <el-input v-model="expressForm.name" class="white" placeholder="请输入名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button class="btn-white" @click="closeDialog">取消</el-button>
          <el-button class="btn-blue" @click="addExpress('expressForm')">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import Carrier from "models/carrier";
import Logistics from "models/logistics";
const logistics = new Logistics();
const carrier = new Carrier();
import { modifyNetTitle } from "common/js/util";
export default {
  data() {
    return {
      name: "",
      searchName: "",
      tableData: [],
      carrierDialog: false,
      carrierForm: {
        name: "",
        type: ""
      },
      carrierFormRules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        type: [{ required: true, message: "请输入名称", trigger: "change" }]
      },
      typeList: [],
      //快递
      expressDialog: false,
      expressForm: {
        name: ""
      },
      expressFormRules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }]
      }
    };
  },
  created() {
    modifyNetTitle('物流匹配规则')
    this.getTableData();
    this.getLogisticsList();
  },
  watch: {
    carrierDialog: {
      handler(newVal) {
        if (!newVal) {
          this.carrierForm.name = "";
          this.carrierForm.type = "";
        }
      }
    },
    expressDialog: {
      handler(newVal) {
        if (!newVal) {
          this.expressForm.name = "";
        }
      }
    }
  },
  methods: {
    getTableData() {
      let name = this.searchName;
      carrier.getExpressList(name).then(res => {
        if (res.success) {
          let tableData = [];
          res.result.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.expressName;
            obj.typeName = value.expressTypeName;
            tableData.push(obj);
          });
          this.tableData = tableData;
        }
      });
    },
    //获取快递列表
    getLogisticsList() {
      logistics.getExpressData().then(res => {
        if (res.success) {
          let arr = [];
          res.result.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.name;
            arr.push(obj);
          });
          this.typeList = arr;
        }
      });
    },
    search() {
      this.searchName = this.name;
      this.getTableData();
    },
    remove(id) {
      this.$confirm("确定删除该数据?", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let data = {
            id
          };
          carrier.postDeleteExpress(data).then(res => {
            if (res.success) {
              this.getTableData();
              this.$message.success("删除成功");
            } else {
              this.$message.error(res.message);
            }
          });
        })
        .catch(() => {});
    },
    addcarrier(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let data = {};
          data.expressName = this.carrierForm.name;
          data.expressType = this.carrierForm.type;
          carrier.postAddExpress(data).then(res => {
            if (res.success) {
              this.closeDialog();
              this.getTableData();
              this.$message.success("添加成功");
              this.$refs[formName].resetFields();
            } else {
              this.$message.error(res.message);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    openDialog() {
      this.carrierDialog = true;
    },
    closeDialog() {
      this.carrierDialog = false;
      this.expressDialog = false;
    },
    openExpressDialog() {
      this.expressDialog = true;
    },
    addExpress(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let data = {};
          data.carrierName = this.expressForm.name;
          carrier.postAddExpressCarrier(data).then(res => {
            if (res.success) {
              this.getLogisticsList();
              this.closeDialog();
            } else {
              this.$message.error(res.message);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.carrier {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  .search-add {
    display: flex;
    justify-content: space-between;
    padding: 16px;
    background: #fff;
    display: flex;
    border-radius: 4px;
    margin-bottom: 16px;
    .el-input {
      width: 240px;
    }
    .el-button {
      margin-left: 16px;
    }
  }
  .table {
    min-height: 500px;
    padding: 16px;
    background: #fff;
    border-radius: 4px;
  }
  .el-select {
    width: 100%;
  }
}
</style>
